<template>
  <button
    class="btn-main"
    type="button"
    :class="btnClass"
    :disabled="disabled"
    @click="handleClick"
  >
    <template v-if="$slots.default || content">
      <slot>{{ content }}</slot>
    </template>
  </button>
</template>

<script>
  export default {
    name: 'VButton',
    props: {
      content: [String, Number],
      disabled: Boolean,
      rightArrow: Boolean,
      leftArrow: Boolean,
      color: String,
    },
    methods: {
      handleClick() {
        if (this.disabled) {
          return;
        }

        this.$emit('click');
      },
    },
    computed: {
      btnClass() {
        const { rightArrow, leftArrow, color } = this;

        return [
          rightArrow ? 'btn-main--icon-r' : null,
          leftArrow ? 'btn-main--icon-l' : null,
          color ? `btn-main--${color}` : null,
        ];
      },
    },
  };
</script>
